<template>
  <v-bottom-sheet
    :value="isVisibleBottomSheet"
    @input="emitClose"
  >
    <v-sheet class="pa-4">
      <div class="lpu-schedule mb-6">
        <div class="text-h6 text--text mb-4">
          {{ $t('График работы', options) }}
        </div>

        <LpuScheduleSkeleton v-if="isVisibleSkeleton" />
        <template v-else>
          <div class="lpu-schedule__days">
            <div
              v-for="(time, day) in schedule.schedule_days"
              :key="day"
              class="lpu-schedule__day"
              :class="{
                'text-subtitle-1 lpu-schedule__day--current': day === schedule.now_weekday_translit,
                'text-body-1': day !== schedule.now_weekday_translit,
              }"
            >
              <div class="lpu-schedule__item">
                {{ $t(schedule.full_days[day], options) }}
              </div>
              <div class="lpu-schedule__item">
                {{ $t(time, options) }}
              </div>
            </div>
          </div>

          <div
            v-if="schedule.lpu_exceptions.length"
            class="mt-6"
          >
            <div class="text-h6 text--text mb-4">
              {{ $t('График работы в праздничные дни', options) }}
            </div>
            <div class="lpu-schedule__days">
              <div
                v-for="(exception, index) in schedule.lpu_exceptions"
                :key="`holiday-${index}`"
                class="lpu-schedule__day text-body-1"
              >
                <div class="lpu-schedule__item">
                  {{ $t(exception.date, options) }}
                </div>
                <div class="lpu-schedule__item">
                  {{ $t(exception.time, options) }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <v-btn
        block
        depressed
        color="primary"
        class="branding-btn branding-btn--primary"
        @click="emitClose"
      >
        {{ $t('Понятно', options) }}
      </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import LpuScheduleSkeleton from 'www/vue_components/common/LpuSchedule/components/common/LpuScheduleSkeleton.vue'

export default {
  name: 'LpuSchedule',
  components: {
    LpuScheduleSkeleton,
  },
  model: {
    prop: 'isVisibleBottomSheet',
    event: 'input',
  },
  props: {
    /**
     * interface
     * schedule: Schedule
     */
    schedule: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isVisibleBottomSheet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: { ns: this.$i18next.language },
    }
  },
  computed: {
    isVisibleSkeleton() {
      return this.loading || !this.schedule
    },
  },
  methods: {
    emitClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.lpu-schedule {
  &__item {
    flex-basis: 50%;
  }

  &__days {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  &__day {
    display: flex;
    column-gap: 16px;

    &--current {
      color: $ui-kit-text;
    }

    &:not(&--current) {
      color: $ui-kit-text-secondary;
    }
  }
}
</style>
